import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { DownloadableConfigurationFiles } from '../../../_lib/components/ConfigurationFileUpload';

type ConfigurationFile = {
  fileExportType: 'standard';
  fileExtension: 'yaml' | 'json';
  url: string;
};
type PluginConfigurationDefaultProps = { files: ConfigurationFile[] };

function PluginConfigurationDefault({ files }: PluginConfigurationDefaultProps) {
  const { uuid, elementType } = useBlockContext();
  const { t } = useSonTranslation('PluginConfiguration');
  return (
    <DownloadableConfigurationFiles
      key={`${elementType}-${uuid}`}
      files={files.map(file => ({
        extension: file.fileExtension,
        url: file.url,
        name: t('fileExportType.customized'),
      }))}
    />
  );
}

export const PluginConfigurationDefaultView = asView(PluginConfigurationDefault);
export type PluginConfigurationDefaultView = ComponentProps<typeof PluginConfigurationDefaultView>;
